import React, { useState } from "react";
import { Modal, Tabs } from "@opendate-app/setlist";
import "./membershipProductEditor.css";

const MODES = [
  { value: "desktop", label: "Desktop" },
  { value: "mobile", label: "Mobile" },
];

const PreviewModal = ({ teamId, membershipProduct, onClose }) => {
  const [previewMode, setPreviewMode] = useState("desktop");
  const mobile = previewMode === "mobile";

  return (
    <Modal
      open
      onClose={onClose}
      title="Widget live preview"
      description="What fans see when they buy this membership."
      width={mobile ? 480 : 860}
      footer={null}
    >
      <div className="membership-preview-modal">
        <Tabs variant="button-border" size="sm" collapseBelow={0} items={MODES} value={previewMode} onChange={setPreviewMode} />
        <iframe
          src={`${window.location.origin}/m/${teamId}/${membershipProduct.slug}/widget`}
          title={membershipProduct.name || "Membership"}
          allowpaymentrequest="true"
          allow="payment"
          className="membership-preview-frame"
          style={{ width: mobile ? 375 : "100%" }}
        />
      </div>
    </Modal>
  );
};

export default PreviewModal;
